module.exports = __webpack_public_path__ + "img/760.9cd6bfe4.jpg";